import OcrmRewardList from './OcrmRewardList';

export default OcrmRewardList;
